/**
 * 공통 Card 컴포넌트
 */

import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';
import { mediaQueries } from '../../../constants/breakpoints';

interface CardProps {
  children: React.ReactNode;
  onClick?: () => void;
  hoverable?: boolean;
  className?: string;
}

const StyledCard = styled.div<{ hoverable?: boolean; onClick?: () => void }>`
  background-color: ${theme.colors.background};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.lg};
  transition: all 0.3s ease-in-out;
  ${({ onClick }) => onClick && `cursor: pointer;`}

  ${({ hoverable }) =>
    hoverable &&
    `
    &:hover {
      box-shadow: ${theme.shadows.md};
      transform: translateY(-4px);
    }
  `}

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.md};
  }
`;

export const Card: React.FC<CardProps> = ({ children, onClick, hoverable = false, className }) => {
  return (
    <StyledCard onClick={onClick} hoverable={hoverable || !!onClick} className={className}>
      {children}
    </StyledCard>
  );
};
